import React from "react";
import { useTranslation } from "../../hooks/useTranslation";
import "../../styles/shared/WhatsIncluded.css";

// Option B — reusable "what's included" card grid for the vehicle pages.
// Content is driven by the `whatsIncluded` i18n namespace so it translates
// across all languages.
//
// The photo slot and the section heading were removed on review: the available
// van photography was not presentable (beds unmade), and the heading copy did
// not survive sign-off. The cards carry the message on their own.

const WhySunCatchers = () => {
  const { t } = useTranslation("whatsIncluded");
  const cards = t("cards", { returnObjects: true }) || [];

  return (
    <section className="wsi-why">
      <div className="wsi-grid">
        {cards.map((card, i) => (
          <article className="wsi-card wsi-card--textonly" key={i}>
            <div className="wsi-card-body">
              <span className={`wsi-pill wsi-pill--${card.badgeType}`}>
                {card.badge}
              </span>
              <h3 className="wsi-card-title">{card.title}</h3>
              <p className="wsi-card-text">{card.text}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default WhySunCatchers;
